<template>
  <div v-if="visible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
      <h2 class="text-lg font-bold mb-4">{{ isEditing ? 'Редактировать компанию' : 'Добавить компанию' }}</h2>

      <form @submit.prevent="saveCompany">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Название компании</label>
          <input
            type="text"
            v-model="form.name"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите название компании"
          />
        </div>

        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">ИНН компании</label>
          <input
            type="text"
            v-model="form.inn"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите ИНН компании"
          />
        </div>

        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Адрес компании</label>
          <textarea
            v-model="form.address"
            rows="3"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите адрес компании"
          />
        </div>

        <div class="flex justify-end space-x-2">
          <button
            type="button"
            @click="closeModal"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            Отмена
          </button>
          <button
            type="submit"
            :disabled="!form.name.trim()"
            class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-600"
          >
            {{ isEditing ? 'Обновить' : 'Добавить' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    company: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      form: {
        id: null,
        name: '',
        inn: '',
        address: ''
      },
    };
  },
  computed: {
    isEditing() {
      return this.company && this.company.id;
    }
  },
  watch: {
    company: {
      handler(newCompany) {
        if (newCompany) {
          this.form = {
            id: newCompany.id,
            name: newCompany.name || '',
            inn: newCompany.inn || '',
            address: newCompany.address || ''
          };
        }
      },
      immediate: true
    }
  },
  methods: {
    saveCompany() {
      if (!this.form.name) {
        console.error('Название компании не может быть пустым');
        return;
      }
      
      const payload = {
        name: this.form.name,
        inn: this.form.inn,
        address: this.form.address
      };
      
      if (this.isEditing) {
        payload.id = this.form.id;
      }

      axios
        .post('/api/company/createOrUpdateCompany', payload)
        .then(() => {
          this.visible = false;
          this.resetForm();
          this.$emit('company-saved');
        })
        .catch((error) => {
          console.error('Ошибка при сохранении компании:', error);
        });
    },
    resetForm() {
      this.form = {
        id: null,
        name: '',
        inn: '',
        address: ''
      };
    },
    closeModal() {
      this.visible = false;
      this.resetForm();
    },
    show() {
      this.visible = true;
    },
  },
};
</script>